module.exports = __webpack_public_path__ + "static/media/mailIcon.8ff23052.svg";